import React from 'react'
import Topo from '../components/Topo'
import Problemas from '../components/Problemas'
import Solucao1 from '../components/Solucao1'
import Clube from '../components/Clube'
import Investimento from '../components/Investimento'
import Faq from '../components/Faq'
import Depoimentos from '../components/Depoimentos'
import Contatos from '../components/Contatos'
import Conteudo from '../components/Conteudo'
import Index from './Index'
import EncerradasBox from '../components/Encerradasbox '
export const RepertorioComportamental = () => {
  return (
    <div>
       <Topo/>
       <Problemas/>
       <Solucao1/>
       <Conteudo/>
       <Depoimentos/>
        <EncerradasBox/> 
       {/* <Investimento/>  */}
       <Faq/>
       <Contatos/>
    </div>
  )
}
